<template>
    <div v-if="$route.meta.requiresAuth" :class="containerClass" @click="onWrapperClick">
        <div v-if="user">
            <div class="layout-sidebar" @click="onSidebarClick">
                <AppMenu @menuitemClick="onMenuItemClick" />
            </div>
            <div class="layout-main-container">
                <AppTopBar @menuToggle="onMenuToggle" />
                <div class="layout-main">
                    <template v-if="(selectedShop?.country_id !== 1 || generateRandomNumber == 1) && (new Date() >= new Date('2025-04-01') && new Date() <= new Date('2025-04-25'))">
                        <div class="seasonalBannerBox">
                            <img class="seasonalBannerImage" src="/images/bes-logo.png" />
                            <p class="m-0 seasonalBannerText" v-html="t('shoptalkEuropeNotification.notificationText')"></p>
                            <a :href="t('shoptalkEuropeNotification.link')" class="seasonalBannerButton">{{ t("shoptalkEuropeNotification.linkText") }}</a>
                        </div>
                    </template>
                    <template v-if="route.name != 'TrustOk' && (selectedShop?.country_id !== 1 || generateRandomNumber == 1) && (new Date() <= new Date('2025-04-01') || new Date() >= new Date('2025-04-25'))">
                        <div class="trustOkBannerBox">
                            <img class="trustOkBannerImage" src="/images/trustOk/trustOK_logo.png" />
                            <p class="m-0 trustOkBannerText" v-html="t('trustOkBanner.text')"></p>
                            <a href="/trust-ok" class="trustOkBannerButton">{{ t("trustOkBanner.linkText") }}</a>
                        </div>
                    </template>
                    <template v-if="route.name != 'CouponsCreation' && selectedShop?.country_id === 1 && generateRandomNumber == 2">
                        <template v-if="screenWidth > 951">
                            <div class="couponsBanner">
                                <p class="couponBannerText" style="margin-top: 15px !important" v-html="t('pages.coupons.banner.mainText')"></p>
                                <a href="/coupons/add" class="couponBannerButton" v-html="t('pages.coupons.banner.buttonText')"></a>
                            </div>
                        </template>
                        <template v-if="screenWidth > 800 && screenWidth <= 950">
                            <div class="couponsBannerMedium">
                                <p class="m-0 couponBannerText" style="margin-left: 1rem !important;" v-html="t('pages.coupons.banner.mainText')"></p>
                                <a href="/coupons/add" class="couponBannerButton" v-html="t('pages.coupons.banner.buttonText')"></a>
                            </div>
                        </template>
                        <template v-if="screenWidth <= 799">
                            <div class="couponsBannerSmall">
                                <p class="m-0 couponBannerTextSmall" style="margin-left: 30px !important; text-align: start !important;" v-html="t('pages.coupons.banner.mainText')"></p>
                                <a href="/coupons/add" class="couponBannerButton" v-html="t('pages.coupons.banner.buttonText')"></a>
                            </div>
                        </template>
                    </template>
                    
                    <div
                        v-if="!user.confirmed"
                        class="card m-0 growth-formula-notification-banner"
                        style="margin-bottom: 17px !important"
                    >
                        <span>
                            <p class="growth-formula-notification-text-bold">
                                <i class="pi pi-info-circle" style="font-size: 2rem; margin-right: 10px"></i>Welcome to
                                Business manager. Take a look around while our team verify your account and give you
                                access to your market insight.
                            </p>
                        </span>
                    </div>
                    <div
                        v-else-if="user.level < 3"
                        class="card m-0 growth-formula-notification-banner"
                        style="margin-bottom: 17px !important"
                    >
                        <span>
                            <p class="growth-formula-notification-text-bold">
                                <i class="pi pi-info-circle" style="font-size: 2rem; margin-right: 10px"></i>In order to
                                get access to your property, please fill out mandatory fields started with
                                <span style="color: red">&#160;*&#160;</span>on your&#160;<router-link to="/profile"
                                    >profile</router-link
                                >.
                            </p>
                        </span>
                    </div>
                    <div
                        class="notification-box"
                        v-if="
                            (selectedShop?.sf_limit_price_c !== null &&
                                selectedShop?.sf_is_active_c == 'Limit Reached') ||
                            (selectedShop?.sf_limit_price_c !== null &&
                                selectedShop?.sf_is_active_c == 'Limit Threshold')
                        "
                    >
                        <template v-if="selectedShop?.sf_is_active_c == 'Limit Reached'">
                            <span class="notification-text">
                                {{ t("pages.limitManagement.notificationLimitReachedPart1") }}
                                <router-link to="/limit-management">{{
                                    t("pages.limitManagement.notificationLimitReachedPart2")
                                }}</router-link>
                                {{ t("pages.limitManagement.notificationLimitReachedPart3") }}
                            </span>
                        </template>
                        <template v-else-if="selectedShop?.sf_is_active_c == 'Limit Threshold'">
                            <span class="notification-text">
                                {{
                                    `${t("pages.limitManagement.notificationLimitThresholdPart1")} ${formatPrice(
                                        selectedShop?.sf_limit_price_c,
                                        2
                                    )} €.`
                                }}
                                {{ t("pages.limitManagement.notificationLimitThresholdPart2") }}
                                <router-link to="/limit-management">{{
                                    t("pages.limitManagement.notificationLimitThresholdPart3")
                                }}</router-link>
                                {{ t("pages.limitManagement.notificationLimitThresholdPart4") }}
                            </span>
                        </template>
                    </div>
                    <router-view v-slot="{ Component }">
                        <transition name="fade" mode="out-in">
                            <component :is="Component" />
                        </transition>
                    </router-view>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppMenu from "../components/common/AppMenu";
import AppTopBar from "../components/common/AppTopBar";
import useHelpers from "@/composables/helpers";
import { computed, ref } from "vue";
import { storeToRefs } from "pinia";
import { useI18n } from "vue-i18n";
import { useShopStore } from "../store/shop";
import { useUserStore } from "../store/user";
import { useRoute } from "vue-router";

export default {
    name: "Main",
    components: {
        AppTopBar,
        AppMenu,
    },
    setup() {
        const layoutMode = ref("static");
        const menuClick = ref(false);
        const mobileMenuActive = ref(false);
        const overlayMenuActive = ref(false);
        const shopStore = useShopStore();
        const staticMenuInactive = ref(false);
        const userStore = useUserStore();
        const { formatPrice } = useHelpers();
        const { selectedShop } = storeToRefs(shopStore);
        const { t } = useI18n();
        const { user } = storeToRefs(userStore);
        const route = useRoute();

        const screenWidth = ref(window.innerWidth);

        const onWrapperClick = () => {
            if (!menuClick.value) {
                overlayMenuActive.value = false;
                mobileMenuActive.value = false;
            }

            menuClick.value = false;
        };

        const onMenuToggle = () => {
            menuClick.value = true;

            if (window.innerWidth >= 992) {
                if (layoutMode.value === "overlay") {
                    if (mobileMenuActive.value === true) {
                        overlayMenuActive.value = true;
                    }

                    overlayMenuActive.value = !overlayMenuActive.value;
                    mobileMenuActive.value = false;
                } else if (layoutMode.value === "static") {
                    staticMenuInactive.value = !staticMenuInactive.value;
                }
            } else {
                mobileMenuActive.value = !mobileMenuActive.value;
            }
        };

        const onSidebarClick = () => {
            menuClick.value = true;
        };

        const onMenuItemClick = (event) => {
            if (event.item && !event.item.items) {
                overlayMenuActive.value = false;
                mobileMenuActive.value = false;
            }
        };

        const containerClass = computed(() => {
            return [
                "layout-wrapper",
                {
                    "layout-overlay": layoutMode.value === "overlay",
                    "layout-static": layoutMode.value === "static",
                    "layout-static-sidebar-inactive": staticMenuInactive.value && layoutMode.value === "static",
                    "layout-overlay-sidebar-active": overlayMenuActive.value && layoutMode.value === "overlay",
                    "layout-mobile-sidebar-active": mobileMenuActive.value,
                },
            ];
        });

        const beautyAndHealthUrl = computed(() => {
            let url = "";

            if (selectedShop?.value?.country_locale_code == "hr") {
                url = "https://www.shoptok.hr/lepota-in-zdravje/cijene/16";
            }

            if (selectedShop?.value?.country_locale_code == "rs") {
                url = "https://www.eponuda.com/zdravlje-i-lepota";
            }

            if (selectedShop?.value?.country_locale_code == "si") {
                url = "https://www.shoptok.si/lepota-in-zdravje/cene/16";
            }

            return url;
        });

        const computersUrl = computed(() => {
            let url = "";

            if (selectedShop?.value?.country_locale_code == "hr") {
                url = "https://www.shoptok.hr/racunalstvo/cijene/1";
            }

            if (selectedShop?.value?.country_locale_code == "rs") {
                url = "https://www.eponuda.com/racunari";
            }

            if (selectedShop?.value?.country_locale_code == "si") {
                url = "https://www.shoptok.si/racunalnistvo/cene/1";
            }

            return url;
        });

        const audioVideoUrl = computed(() => {
            let url = "";

            if (selectedShop?.value?.country_locale_code == "hr") {
                url = "https://www.shoptok.hr/audio-video/cene/3";
            }

            if (selectedShop?.value?.country_locale_code == "rs") {
                url = "https://www.eponuda.com/audio-video";
            }

            if (selectedShop?.value?.country_locale_code == "si") {
                url = "https://www.shoptok.si/avdio-video/cene/3";
            }

            return url;
        });

        const generateRandomNumber = computed(() => {
            const randomNumber = Math.random();
            const result = Math.round(randomNumber);
            return result + 1;
        });

        return {
            audioVideoUrl,
            beautyAndHealthUrl,
            computersUrl,
            containerClass,
            formatPrice,
            generateRandomNumber,
            mobileMenuActive,
            onMenuItemClick,
            onMenuToggle,
            onSidebarClick,
            onWrapperClick,
            route,
            selectedShop,
            screenWidth,
            t,
            user,
        };
    },
};
</script>

<style scoped>
.notification-box {
    align-items: center;
    background: #fffeb5;
    border-radius: 5px;
    display: inline-flex;
    gap: 5px;
    justify-content: space-between;
    margin-bottom: 14px;
    padding: 15px 20px;
    width: 100%;
}
.notification-logo {
    height: 30px;
}
.notification-button {
    background: #fcee21;
    border-radius: 20px;
    border: 1px solid #000;
    color: #000;
    cursor: pointer;
    font-weight: 600;
    padding: 10px 20px;
    white-space: nowrap;
}

.notification-button:hover {
    background: #000;
    color: white;
}

.notification-button:active {
    background: #999;
    color: white;
}

@media (max-width: 600px) {
    .notification-box {
        font-size: 10px;
    }

    .notification-logo {
        height: 16px;
    }

    .notification-button {
        font-size: 10px;
    }
}

.trustOkBannerBox {
    align-items: center;
    background: #e7ffe4;
    border-radius: 5px;
    display: flex;
    gap: 15px;
    justify-content: space-between;
    margin-bottom: 14px;
    padding: 15px 20px;
    width: 100%;
}


.couponsBanner {
    display: flex;
    gap: 30px;
    width: 100%;
    height: 62px;
    padding: 15px 20px;
    margin-bottom: 14px;
    background: url('/images/coupons/coupons_banner_lg.png') lightgray 50% / cover no-repeat;
    background-position: initial; /* or any other position like center, bottom left, etc. */
    border-radius: 5px;
    justify-content: center;
    align-items: center;
}

.couponsBannerMedium {
    display: flex;
    gap: 30px;
    width: 100%;
    height: 62px;
    margin-bottom: 14px;
    padding: 15px 20px;
    justify-content: center;
    align-items: center;
    background: url('/images/coupons/coupon_banner.png') lightgray 50% / cover no-repeat;
    border-radius: 5px;
}

.couponsBannerSmall {
    display: flex;
    width: 100%;
    height: 62px;
    padding: 15px 20px;
    margin-bottom: 14px;
    justify-content: space-between;
    align-items: center;
    gap: 30px;
    background: url('/images/coupons/coupon_banner.png') lightgray 50% / cover no-repeat;
    border-radius: 5px;
}

.trustOkBannerImage {
    height: 100%;
}

.trustOkBannerText {
    color: #000;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-align: center;
}

.couponBannerText {
    color: #000;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.couponBannerTextSmall {
    color: #000;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.trustOkBannerButton {
    align-items: center;
    align-items: center;
    background: #00e606;
    border-radius: 10px;
    color: #fff;
    cursor: pointer;
    display: flex;
    display: flex;
    font-family: Sora;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    gap: 10px;
    justify-content: center;
    line-height: normal;
    padding: 11px 23px;
    white-space: nowrap;
}

.trustOkBannerButton:hover {
    background: #0f0;
}

.couponBannerButton {
    align-items: center;
    background: #3E61FF;
    border-radius: 10px;
    color: #fff;
    cursor: pointer;
    display: flex;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    gap: 10px;
    justify-content: center;
    line-height: normal;
    padding: 11px 23px;
    white-space: nowrap;
}

.couponBannerButton:hover {
    background: #3E61FF;
}


.trustOkBannerButton:active {
    background: #56ff50;
}

.seasonalBannerBox {
    display: flex;
    width: 100%;
    height: 70px;
    padding: 15px 20px;
    justify-content: space-between;
    align-items: center;
    gap: 15px;
    flex-shrink: 0;
    border-radius: 5px;
    background: #2A1477;
    margin-bottom: 10px;
}

.seasonalBannerImage {
    width: 8%;
}

.seasonalBannerText {
    color: #FFF;
    font-family: Inter;
    font-size: clamp(1px, 13px, 13px);
    min-height: 15px;
    max-height: 50px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-align: center;
}

.seasonalBannerButton {
    display: flex;
    padding: 11px 23px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 100px;
    min-width: 161px;
    max-width: 175px;
    height: 40px;
    border: 1px solid #000;
    background: #D8358E;
    color: #FFF;

    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}


.seasonalBannerButton:hover {
    border-radius: 100px;
    border: 1px solid #000;
    background: #000;
    color: #FFF;
}

.seasonalBannerButton:active {
    border-radius: 100px;
    border: 1px solid #000;
    background: #393939;
    color: #FFF;
}

@media (max-width: 1000px) {
    .seasonalBannerImage {
        width: 160px;
    }
}

@media (max-width: 700px) {
    .trustOkBannerBox {
        flex-direction: column;
    }

    /* .seasonalBannerBox {
        flex-direction: column;
        padding: 15px 20px;
        height: auto;
    } */
}
</style>
